import { j as s } from "./jsx-runtime-DmTjM30f.js";
import { useCallback as l } from "react";
import { P as d } from "./index.esm-G8KyR0tM.js";
import { i as r } from "./index-wI714H_N.js";
function j({ disableBackButton: i = !1, pageTitle: e, content: n }) {
  const a = l(() => {
    i || window.history.back();
  }, []);
  return /* @__PURE__ */ s.jsxs(s.Fragment, {
    children: [
      /* @__PURE__ */ s.jsx(d, {
        title: e || r._({
          id: "7u8l4U"
        }),
        icon: i ? "" : "Back",
        onClick: a,
        customClass: "mb-4"
      }),
      /* @__PURE__ */ s.jsx("div", {
        children: n ? /* @__PURE__ */ s.jsx(s.Fragment, {
          children: n
        }) : /* @__PURE__ */ s.jsx(t, {})
      })
    ]
  });
}
const t = () => /* @__PURE__ */ s.jsxs("div", {
  className: "dark:text-neutral-40 leading-relaxed",
  children: [
    /* @__PURE__ */ s.jsx("p", {
      className: "pb-2",
      children: r._({
        id: "Kgj7HF"
      })
    }),
    /* @__PURE__ */ s.jsx("p", {
      className: "pb-2",
      children: r._({
        id: "1lrkXw"
      })
    }),
    /* @__PURE__ */ s.jsx("p", {
      className: "pb-2",
      children: r._({
        id: "xTR2uF"
      })
    })
  ]
});
export {
  j as T
};
